<template>
  <v-form @submit.prevent="submit">
    <div class="containerInsured2">
      <v-row>
        <v-spacer />
        <QuotationFloatActionButton
          class="messageInfoInsured2"
          v-if="!getIsEmployeeUser"
          :message="infoMessage"
        />
      </v-row>
      <QuotationInsuredForm2
        ref="form"
        @submit="submit"
        @cancel="cancelQuotationButton"
        v-model="formInsured2"
        :options-quotation="optionsQuotation"
        :formInsured="formInsured"
        :formLocation="formLocation"
      />
      <BaseFooter v-if="currentQuotation.cancelada_em == null">
        <v-row>
          <v-spacer />
          <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
            <BaseButton
              v-html="'CANCELAR SOLICITAÇÃO'"
              class="white--text pink"
              width="100%"
              @click="cancelQuotation"
            />
          </v-col>
          <v-col cols="12" sm="5" md="3">
            <BaseButton
              v-html="'PRÓXIMO'"
              class="white--text secondary"
              width="100%"
              @click="submit()"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </div>
  </v-form>
</template>
<script>
import QuotationInsuredForm2 from "../components_agro/QuotationInsuredForm2.vue";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { mapState } from "vuex";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

export default {
  name: "QuotationStepInsured2",
  data: () => ({
    formInsured2: {}
  }),
  components: {
    QuotationInsuredForm2,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin],
  computed: {
    ...mapState("quotation", ["currentQuotation"]),
    ...mapState("me", ["userIsEmployee"]),
    nextQuotationStep() {
      return {
        name: "quotation step risk2",
        step: 7
      };
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return "Preencha as informações do segurado e clique em próximo para avançar.";
    }
  },
  created() {
    this.formInsured2 = this.form;
  },
  methods: {
    getFormForNavigation() {
      return this.formInsured2;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit(
          "updateStep",
          this.payloadQuotation(this.formInsured2, this.nextQuotationStep)
        );
      }
    },
    cancelQuotation() {
      this.$emit("cancel");
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    formInsured: {
      type: Object
    },
    formLocation: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.containerInsured2
  margin-left: 40px  
.messageInfoInsured2
  margin-top: -58px
  margin-right: 75px
</style>
